import { i18n } from '@lingui/core'
import { t } from '@lingui/macro'
import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { currencyFormatedString } from 'app/views/common/Formats'
import { PdfSplittableTableRow } from 'app/views/forms/pdf-components/PdfSplittableTableRow'
import { PdfTableCell } from 'app/views/forms/pdf-components/PdfTableCell'
import { PdfTableHeaderCell } from 'app/views/forms/pdf-components/PdfTableHeaderCell'
import {
  pdfTableCellTextStyle,
  pdfTableStyles
} from 'app/views/forms/pdf-components/PdfTableStyles'
import { PdfUnsplittableTableRow } from 'app/views/forms/pdf-components/PdfUnsplittableTableRow'
import React from 'react'
import { grantStatusOptions } from './FormOtherGrants'

const styles = StyleSheet.create({
  col: {
    width: '33.33%'
  }
})

interface OtherGrant {
  name?: string
  value?: number
  state?: string
}

interface FormOtherGrantsPdfProps {
  value?: OtherGrant[]
  langVersion: string
}

const getStatusLabel = (state?: string): string => {
  const option = grantStatusOptions.find((option) => option.value === state)
  return option ? i18n._(option.pdfLabelId) : ''
}

export const FormOtherGrantsPdf = ({
  value = [],
  langVersion
}: FormOtherGrantsPdfProps): React.ReactElement => {
  if (value.length === 0) {
    return (
      <Text style={pdfTableCellTextStyle}>{i18n._(t`PDF_ELEMENT_OTHER_GRANTS_NONE_LABEL`)}</Text>
    )
  }

  return (
    <View style={pdfTableStyles.table}>
      <PdfUnsplittableTableRow>
        <PdfTableHeaderCell style={styles.col}>{i18n._(t`Name`)}</PdfTableHeaderCell>
        <PdfTableHeaderCell style={styles.col}>{i18n._(t`Value`)}</PdfTableHeaderCell>
        <PdfTableHeaderCell style={styles.col}>{i18n._(t`Status`)}</PdfTableHeaderCell>
      </PdfUnsplittableTableRow>

      {value.map((grant, index) => (
        <PdfSplittableTableRow key={index}>
          <PdfTableCell style={styles.col}>
            <Text>{grant.name}</Text>
          </PdfTableCell>
          <PdfTableCell style={styles.col}>
            <Text>{currencyFormatedString(grant.value, langVersion)}</Text>
          </PdfTableCell>
          <PdfTableCell style={styles.col}>
            <Text>{getStatusLabel(grant.state)}</Text>
          </PdfTableCell>
        </PdfSplittableTableRow>
      ))}
    </View>
  )
}
